/*全局
一些公用方法*/
// 数组求和方法
Array.prototype.sum = function() {
    return this.reduce(function(partial, value) {
        return partial + value;
    })
};
/**
 * 
 * 查找数组，返回匹配到的第一个index 或者obj
 *
 * @param array 被查找的数组
 * @param feature 查找特征 或者为一个具体值，用于匹配数组遍历的值，或者为一个对象，表明所有希望被匹配的key-value
 * @param or boolean 希望命中feature全部特征或者只需命中一个特征，默认true
 * @return 查找特征如果为简单值则返回数组下标，如果为对象则根据rtnobj参数返回该对象或者下标 查找不到返回-1
 * 使用方法
 * 单指数组返回索引 var index = arr.findItem(3);
 * ObjectArray默认返回该Obj 
 * var index = arr.findItem({id: '2',name: '习大大'});
 * 加上参数返回obj索引 以及命中方法切换
 * var index = arr.findItem({id : '2',name: '习大大'},false,false);
 */
Array.prototype.findItem = function(feature, rtnobj = true, all = true) {
    for (let index in this) {
        let cur = this[index];
        if (feature instanceof Object) {
            let allRight = true;
            for (let key in feature) {
                let value = feature[key];
                if (!all) {
                    allRight = false;
                    if (cur[key] == value) {
                        return rtnobj ? cur : index
                    };
                }
                if (all && cur[key] != value) {
                    allRight = false;
                    break;
                }
            }
            if (allRight) {
                return rtnobj ? cur : index
            };
        } else {
            if (cur == feature) {
                return index;
            }
        }
    }
    return -1;
};
// 字符串模糊查找
String.prototype.like = function(keyword) {
    var str = this.toLowerCase(),
        keyword = keyword.toLowerCase();
    if (str.indexOf(keyword) == -1) {
        return false;
    } else {
        return true;
    };
};